document.addEventListener('DOMContentLoaded', function () {
  try {
    const init = () => {
      const hamburgerTrigger = document.getElementById('hh-trigger')
      if (!hamburgerTrigger) return

      const hamburgerLink = hamburgerTrigger.parentElement
      if (hamburgerLink && hamburgerLink.tagName.toLowerCase() === 'a') {
        // Kopiere eventuelle wichtige Attribute vom Link
        const linkAttributes = hamburgerLink.attributes
        for (let attr of linkAttributes) {
          if (attr.name !== 'href' && attr.name !== 'id') {
            hamburgerTrigger.setAttribute(attr.name, attr.value)
          }
        }

        // Füge den Button vor dem Link ein und entferne den Link
        hamburgerLink.parentNode.insertBefore(hamburgerTrigger, hamburgerLink)
        hamburgerLink.remove()
      }
    }

    // Versuche die Ausführung sowohl beim DOMContentLoaded als auch beim Load Event
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init)
    } else {
      init()
    }
    // Zusätzlicher Fallback
    window.addEventListener('load', init)
  } catch (error) {
    console.error('Error handling hamburger menu:', error)
  }

  const menuToggle = document.getElementById('hh-trigger')
  const mainMenuWrapper = document.querySelector('.main-menu__wrapper')
  const menuItems = mainMenuWrapper.querySelectorAll('a')
  const subMenus = document.querySelectorAll('.sub-menu__wrapper')
  let lastFocusedElement = null
  let isKeyboardNavigation = false

  // Tastaturnavigation erkennen
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') {
      isKeyboardNavigation = true
    }
  })

  document.addEventListener('mousedown', function () {
    isKeyboardNavigation = false
  })

  function setMenuItemsFocusable(focusable, elements) {
    elements.forEach((item) => {
      if (focusable) {
        item.removeAttribute('tabindex')
      } else {
        item.setAttribute('tabindex', '-1')
      }
    })
  }

  function closeSubmenu(submenu) {
    submenu.classList.remove('is-active')
    submenu.setAttribute('aria-hidden', 'true')
    const parentLink = document.querySelector(`[aria-controls="${submenu.id}"]`)
    if (parentLink) {
      parentLink.setAttribute('aria-expanded', 'false')
    }
    setMenuItemsFocusable(false, submenu.querySelectorAll('a'))

    // Bei Tastaturnavigation Fokus auf Parent-Link setzen
    if (isKeyboardNavigation && parentLink) {
      parentLink.focus()
    }
  }

  function closeAllSubmenus() {
    subMenus.forEach((submenu) => {
      closeSubmenu(submenu)
    })
  }

  // Verbesserte Focus-Trap
  function handleFocusTrap(e) {
    if (e.key !== 'Tab') return

    const activeSubmenu = document.querySelector('.sub-menu__wrapper.is-active')
    const container = activeSubmenu || mainMenuWrapper
    const focusableElements = container.querySelectorAll('a:not([tabindex="-1"]), button:not([disabled])')

    const firstElement = focusableElements[0]
    const lastElement = focusableElements[focusableElements.length - 1]

    if (e.shiftKey && document.activeElement === firstElement) {
      e.preventDefault()
      if (activeSubmenu) {
        // Wenn im Submenü, zum Parent zurück
        const parentLink = document.querySelector(`[aria-controls="${activeSubmenu.id}"]`)
        closeSubmenu(activeSubmenu)
        parentLink.focus()
      } else {
        lastElement.focus()
      }
    } else if (!e.shiftKey && document.activeElement === lastElement) {
      e.preventDefault()
      if (activeSubmenu) {
        closeSubmenu(activeSubmenu)
      } else {
        firstElement.focus()
      }
    }
  }

  // Hauptmenü Toggle mit verbesserter Fokus-Verwaltung
  menuToggle.addEventListener('click', function () {
    const scrollPos = window.scrollY
    const isExpanding = this.getAttribute('aria-expanded') === 'false'

    // Direkt ein requestAnimationFrame um instant zurückzuscrollen
    requestAnimationFrame(() => window.scrollTo(0, scrollPos))

    if (isExpanding) {
      document.documentElement.style.setProperty('--scroll-position', `${scrollPos}px`)
    }

    this.setAttribute('aria-expanded', isExpanding)
    this.classList.toggle('is-active')
    mainMenuWrapper.classList.toggle('is-active')

    setMenuItemsFocusable(isExpanding, menuItems)

    if (isExpanding) {
      if (isKeyboardNavigation) {
        menuItems[0].focus()
      }
      document.addEventListener('keydown', handleFocusTrap)
    } else {
      closeAllSubmenus()
      if (isKeyboardNavigation && lastFocusedElement) {
        lastFocusedElement.focus()
      }
      document.removeEventListener('keydown', handleFocusTrap)
    }
  })

  // Verbesserte Submenü-Interaktion
  menuItems.forEach((item) => {
    const submenuId = item.getAttribute('aria-controls')
    if (submenuId) {
      const submenu = document.getElementById(submenuId)

      item.addEventListener('click', function (e) {
        e.preventDefault()
        const isExpanding = this.getAttribute('aria-expanded') === 'false'

        // Schließe andere Submenüs
        subMenus.forEach((otherSubmenu) => {
          if (otherSubmenu !== submenu && otherSubmenu.classList.contains('is-active')) {
            closeSubmenu(otherSubmenu)
          }
        })

        this.setAttribute('aria-expanded', isExpanding)
        submenu.classList.toggle('is-active')
        submenu.setAttribute('aria-hidden', !isExpanding)

        const submenuItems = submenu.querySelectorAll('a')
        setMenuItemsFocusable(isExpanding, submenuItems)

        if (isExpanding && isKeyboardNavigation) {
          submenuItems[0].focus()
        }
      })
    }
  })

  // Escape-Taste Handler mit verbesserter Fokus-Logik
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      const activeSubmenu = document.querySelector('.sub-menu__wrapper.is-active')
      if (activeSubmenu) {
        const parentLink = document.querySelector(`[aria-controls="${activeSubmenu.id}"]`)
        closeSubmenu(activeSubmenu)
        if (isKeyboardNavigation && parentLink) {
          parentLink.focus()
        }
      } else if (mainMenuWrapper.classList.contains('is-active')) {
        menuToggle.click()
        if (isKeyboardNavigation) {
          menuToggle.focus()
        }
      }
    }
  })

  // Klick außerhalb schließen
  document.addEventListener('click', function (e) {
    if (!mainMenuWrapper.contains(e.target) && !menuToggle.contains(e.target)) {
      if (mainMenuWrapper.classList.contains('is-active')) {
        menuToggle.setAttribute('aria-expanded', 'false')
        menuToggle.classList.remove('is-active')
        mainMenuWrapper.classList.remove('is-active')
        closeAllSubmenus()
        setMenuItemsFocusable(false, menuItems)

        // Fokus nur bei Tastaturnavigation zurücksetzen
        if (isKeyboardNavigation && lastFocusedElement) {
          lastFocusedElement.focus()
        }
        document.removeEventListener('keydown', handleFocusTrap)
      }
    }
  })

  // Initial alle Menüelemente nicht fokussierbar machen
  setMenuItemsFocusable(false, menuItems)
})

// Grid-Positionierung des Hamburger-Buttons
function positionHamburgerButton() {
  const gridContainer = document.getElementById('masthead')
  const hamburgerButton = document.getElementById('hh-toggle')

  if (!gridContainer || !hamburgerButton) return

  const breakoutStart =
    gridContainer.offsetLeft +
    getComputedStyle(gridContainer)
      .getPropertyValue('grid-template-columns')
      .split(' ')
      .slice(0, 3)
      .reduce((acc, val) => acc + parseFloat(val), 0)

  hamburgerButton.style.left = `${breakoutStart}px`
}

// Positionierung beim Laden und Resize
document.addEventListener('DOMContentLoaded', positionHamburgerButton)
// Optional: Kommentiert, da es in Ihrem Original-Code auch auskommentiert war
// window.addEventListener('resize', positionHamburgerButton)

//  bestimme die pos des grids
function positionHamburgerButton() {
  // Referenz zum Grid-Container mit der ID 'masthead'
  const gridContainer = document.getElementById('masthead')

  // Referenz zum Hamburger-Button mit der ID 'hh-toggle'
  const hamburgerButton = document.getElementById('hh-toggle')

  // Berechnen Sie die Position der breakout-start-Linie
  const breakoutStart =
    gridContainer.offsetLeft +
    getComputedStyle(gridContainer)
      .getPropertyValue('grid-template-columns')
      .split(' ')
      .slice(0, 3)
      .reduce((acc, val) => acc + parseFloat(val), 0)

  // Setzen Sie die left-Position des Buttons
  hamburgerButton.style.left = `${breakoutStart}px`
}

// Führen Sie die Funktion aus, wenn das Dokument geladen ist
document.addEventListener('DOMContentLoaded', positionHamburgerButton)

// Führen Sie die Funktion erneut aus, wenn das Fenster seine Größe ändert
window.addEventListener('resize', positionHamburgerButton)
